import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstancehlive1cpt4pr as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.f2t_1.j2t(6);
  if ($this.f2t_1.k2t() === 4) {
    $this.f2t_1.e2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.f2t_1.l2t()) {
    var key = $this.g2t_1 ? $this.f2t_1.n2t() : $this.f2t_1.m2t();
    $this.f2t_1.j2t(5);
    var element = $this.o2t();
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.f2t_1.p2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.f2t_1.e2s('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.f2t_1.j2t(7);
  } else if (lastToken === 4) {
    if (!$this.h2t_1) {
      invalidTrailingComma($this.f2t_1);
    }
    $this.f2t_1.j2t(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.f2t_1.j2t(6);
  if ($this.f2t_1.k2t() === 4) {
    $this.f2t_1.e2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().bc();
  $l$loop: while ($this.f2t_1.l2t()) {
    var key = $this.g2t_1 ? $this.f2t_1.n2t() : $this.f2t_1.m2t();
    $this.f2t_1.j2t(5);
    var element = yield* $receiver.os(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.f2t_1.p2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.f2t_1.e2s('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.f2t_1.j2t(7);
  } else if (lastToken === 4) {
    if (!$this.h2t_1) {
      invalidTrailingComma($this.f2t_1);
    }
    $this.f2t_1.j2t(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.f2t_1.p2t();
  if ($this.f2t_1.k2t() === 4) {
    $this.f2t_1.e2s('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.f2t_1.l2t()) {
    var element = $this.o2t();
    result.i2(element);
    lastToken = $this.f2t_1.p2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.f2t_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.o2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.e2s(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.f2t_1.j2t(9);
  } else if (lastToken === 4) {
    if (!$this.h2t_1) {
      invalidTrailingComma($this.f2t_1, 'array');
    }
    $this.f2t_1.j2t(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.g2t_1 || !isString) {
    tmp = $this.f2t_1.n2t();
  } else {
    tmp = $this.f2t_1.m2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda_0($this)), Unit_instance);
}
var JsonTreeReader$readDeepRecursive$slambdaClass;
function JsonTreeReader$readDeepRecursive$slambda() {
  if (JsonTreeReader$readDeepRecursive$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.q2t_1 = this$0;
      }
      *r2t($this$DeepRecursiveFunction, it, $completion) {
        var tmp0_subject = this.q2t_1.f2t_1.k2t();
        var tmp;
        if (tmp0_subject === 1) {
          tmp = readValue(this.q2t_1, true);
        } else if (tmp0_subject === 0) {
          tmp = readValue(this.q2t_1, false);
        } else if (tmp0_subject === 6) {
          tmp = yield* /*#__NOINLINE__*/readObject_0(this.q2t_1, $this$DeepRecursiveFunction, $completion);
        } else if (tmp0_subject === 8) {
          tmp = readArray(this.q2t_1);
        } else {
          this.q2t_1.f2t_1.e2s("Can't begin reading element, unexpected token");
        }
        return tmp;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope() ? p1 : THROW_CCE();
        return this.r2t(tmp, p2 instanceof Unit() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    JsonTreeReader$readDeepRecursive$slambdaClass = $;
  }
  return JsonTreeReader$readDeepRecursive$slambdaClass;
}
function JsonTreeReader$readDeepRecursive$slambda_0(this$0) {
  var i = new (JsonTreeReader$readDeepRecursive$slambda())(this$0);
  var l = ($this$DeepRecursiveFunction, it, $completion) => i.r2t($this$DeepRecursiveFunction, it, $completion);
  l.$arity = 2;
  return l;
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.f2t_1 = lexer;
        this.g2t_1 = configuration.p2n_1;
        this.h2t_1 = configuration.b2o_1;
        this.i2t_1 = 0;
      }
      o2t() {
        var token = this.f2t_1.k2t();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.i2t_1 = this.i2t_1 + 1 | 0;
          if (this.i2t_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.i2t_1 = this.i2t_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.f2t_1.e2s('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
